"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const home_1 = __importDefault(require("@views/home"));
const posts_1 = __importDefault(require("@views/posts"));
const post_1 = __importDefault(require("@views/posts/post"));
const guest_book_1 = __importDefault(require("@views/guest-book"));
const error_1 = __importDefault(require("@views/error"));
const routes = {
    "/": home_1.default,
    "/posts": posts_1.default,
    "/posts/:id": post_1.default,
    "/guestBook": guest_book_1.default,
};
const pathToRegex = (path) => new RegExp("^" + path.replace(/\//g, "\\/").replace(/:\w+/g, "([^/]+)") + "$");
// 끝 슬래시 제거
const normalizePath = (pathname) => pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
async function router() {
    const appDiv = document.getElementById("app");
    if (!appDiv)
        return;
    // 주소 정규화 필요하면 replaceState로 교체(히스토리 안 늘림)
    const current = location.pathname;
    const normalized = normalizePath(current);
    if (normalized !== current) {
        history.replaceState(null, "", normalized + location.search + location.hash);
    }
    const path = normalized;
    for (const [routePath, viewFn] of Object.entries(routes)) {
        const match = path.match(pathToRegex(routePath));
        if (match) {
            try {
                const params = match.slice(1);
                const view = await viewFn(...params);
                if (typeof view === "string") {
                    appDiv.innerHTML = view;
                }
                else if (view instanceof HTMLElement) {
                    appDiv.replaceChildren(view);
                }
            }
            catch (err) {
                console.error(err);
                appDiv.replaceChildren((0, error_1.default)());
            }
            return;
        }
    }
    appDiv.replaceChildren((0, error_1.default)());
}
exports.default = router;
